document.querySelector('.header-wrapper-inner__search-trigger').addEventListener('click', function(){
    this.closest('.header-wrapper-inner__search').classList.toggle('search--opened');
});

document.querySelector('.mobile-navigation__burger').addEventListener('click', function(){
    this.closest('.mobile-navigation-wrapper').classList.toggle('mobile-navigation-wrapper--closed');
    document.body.classList.toggle('overflow-hidden');
    document.querySelector('html').classList.toggle('overflow-hidden');
});

(function() {
  var header = document.querySelector(".main-header-wrapper");
  if (!header) return;

  var lastScrollY = 0;
  var ticking = false;

  function onScroll() {
    lastScrollY = window.pageYOffset;
    if (!ticking) {
      window.requestAnimationFrame(function() {
        if (lastScrollY > 0) {
          header.classList.add("sticky");
          document.querySelector('main').classList.add('sticky-head');
        } else {
          header.classList.remove("sticky");
          document.querySelector('main').classList.remove('sticky-head');
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
